import {
  FormControl,
  FormControlProps,
  FormLabel,
  Switch,
} from "@chakra-ui/react";
import React, { useState } from "react";
import useInProgressDisable from "../../hooks/useInProgressDisable";
import { YesNo } from "../../lib/models/enums";

export type SwitchFieldProps = {
  label?: string;
  name: string;
  size?: string;
  errorText?: string;
  inputValue?: YesNo;
  changeHandler?: (includedInQuote: YesNo) => void;
  disabled?: boolean;
  switchProps?: FormControlProps;
};

function SwitchField(props: SwitchFieldProps) {
  const {
    name,
    inputValue,
    changeHandler,
    size,
    label,
    switchProps,
    disabled,
  } = props;
  const [checked, setChecked] = useState<YesNo>(inputValue ?? YesNo.No);

  const handleChange = (e: any) => {
    const checked = e.target.checked;
    const value = checked ? YesNo.Yes : YesNo.No;
    setChecked(value);
    if (changeHandler) {
      changeHandler(value);
    }
  };

  return (
    <FormControl display="flex" alignItems="center" {...switchProps}>
      <FormLabel fontSize="md" htmlFor={name} mb="0">
        {label}
      </FormLabel>
      <Switch
        onChange={handleChange}
        size={size}
        id={name}
        isDisabled={useInProgressDisable(name) || disabled}
        isChecked={checked === YesNo.Yes}
        data-testid={`${name}-switch`}
      />
    </FormControl>
  );
}

export default SwitchField;
